import { http, setTokens, clearTokens } from './client';

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: 'Bearer';
  expires_in: number;
  user: {
    id: string;
    username: string;
    full_name: string;
    must_change_password: boolean;
  };
}

export interface MeResponse {
  id: string;
  username: string;
  full_name: string;
  designation: string | null;
  must_change_password?: boolean;
  roles: { code: string; scope_type: string; scope_id: number | null }[];
  permissions: string[];
}

export async function login(username: string, password: string): Promise<LoginResponse> {
  const { data } = await http.post<LoginResponse>('/auth/login', { username, password });
  setTokens(data.access_token, data.refresh_token);
  return data;
}

export async function fetchMe(): Promise<MeResponse> {
  const { data } = await http.get<MeResponse>('/auth/me');
  return data;
}

export async function logout(): Promise<void> {
  try {
    const refresh = localStorage.getItem('ahd_refresh_token');
    if (refresh) await http.post('/auth/logout', { refresh_token: refresh });
  } catch {
    // ignore — logging out always succeeds client-side
  } finally {
    clearTokens();
  }
}
